import React from "react";
import SEO from "../../components/seo";


const introText = {
	fontFamily: "var(--body-font)",
	fontSize: 17,
	lineHeight: 1.7,
	color: "var(--text-muted)",
	margin: "0 0 40px",
};

const sectionHeading = {
	fontFamily: "var(--heading-font)",
	fontWeight: 700,
	fontSize: 22,
	lineHeight: 1.3,
	color: "var(--text)",
	margin: "0 0 20px",
	borderLeft: "4px solid var(--primary)",
	paddingLeft: 16,
};

const methodRow = {
	display: "flex",
	alignItems: "flex-start",
	gap: 16,
	padding: "16px 0",
	borderBottom: "1px solid var(--border)",
};

const methodLabel = {
	fontFamily: "var(--heading-font)",
	fontWeight: 700,
	fontSize: 16,
	color: "var(--text)",
	margin: 0,
	display: "flex",
	alignItems: "center",
	gap: 10,
	minWidth: 160,
};

const preferredBadge = {
	display: "inline-block",
	fontFamily: "var(--body-font)",
	fontSize: 10.5,
	fontWeight: 700,
	letterSpacing: "0.05em",
	textTransform: "uppercase",
	color: "#fff",
	background: "var(--primary)",
	borderRadius: 999,
	padding: "3px 9px",
};

const methodDetail = {
	fontFamily: "var(--body-font)",
	fontSize: 15.5,
	lineHeight: 1.6,
	color: "var(--text-muted)",
	margin: 0,
};

const noteBox = {
	background: "var(--tint-warm)",
	border: "1px solid var(--warm-light)",
	borderRadius: 12,
	padding: "20px 24px",
	marginBottom: 24,
};

const noteHeading = {
	fontFamily: "var(--heading-font)",
	fontWeight: 700,
	fontSize: 15.5,
	color: "var(--warm-dark)",
	margin: "0 0 8px",
};

const noteText = {
	fontFamily: "var(--body-font)",
	fontSize: 15,
	lineHeight: 1.7,
	color: "var(--text)",
	margin: 0,
};

const NewReferrals = () => {
	return (
		<div>
			<SEO
				title="New Referrals"
				keywords={[
					`New referrals`,
					`GP referral`,
					`Healthlink`,
					`Referral process`,
					`Gastroenterologist`,
					`Hepatologist`,
					`Rheumatologist`,
					`Dr Spiro Raftopoulos`,
					`Dr Ian Yusoff`,
				]}
				description="How to send a referral to Advanced GI WA and what to expect from our referral process"
			/>

			<p style={introText}>
				Advanced GI WA is a busy specialist practice. To make sure every referral is handled fairly and
				efficiently, we use a structured referral process: every referral we receive is reviewed by one of our
				specialists and triaged according to clinical priority before an appointment is booked. This helps us
				see patients with more urgent conditions sooner, while still processing every referral we receive in a
				timely manner.
			</p>

			<h2 style={sectionHeading}>How your GP should send your referral</h2>
			<div style={{ marginBottom: 32 }}>
				<div style={methodRow}>
					<p style={methodLabel}>
						Healthlink <span style={preferredBadge}>Preferred</span>
					</p>
					<p style={methodDetail}>
						Healthlink is the fastest and most reliable way for your GP to send a referral, and is our
						preferred method.
					</p>
				</div>
				<div style={methodRow}>
					<p style={methodLabel}>Fax</p>
					<p style={methodDetail}>(08) 9389 1755</p>
				</div>
				<div style={{ ...methodRow, borderBottom: "none" }}>
					<p style={methodLabel}>Email</p>
					<p style={methodDetail}>bookings@advancedgiwa.com.au</p>
				</div>
			</div>

			<div style={noteBox}>
				<p style={noteHeading}>If your referral is emailed</p>
				<p style={noteText}>
					Please send a clear, scanned copy of the referral rather than a photo taken on a phone. Phone photos
					are often difficult to read clearly, and an unclear referral will delay processing while we contact
					your GP for a clearer copy.
				</p>
			</div>

			<div style={{ ...noteBox, marginBottom: 0 }}>
				<p style={noteHeading}>Before you call to check on your referral</p>
				<p style={noteText}>
					Once a referral is sent, it takes time to be uploaded into our system and reviewed by the doctor
					before an appointment can be booked. Please allow at least three business days from when your
					referral was sent before contacting our practice to check on its progress.
				</p>
			</div>
		</div>
	);
};

export default NewReferrals;
